import type { NavigationStoreState } from '@base/types/navigation';
import { create } from 'zustand';

// Stores common data required across diferent pages but external
// to the pure navigation state

interface NavigationStore {
  navigationStore: NavigationStoreState;
  setNavigationStore: (state: Partial<NavigationStoreState>) => void;
  resetNavigationStore: () => void;
}

export const useNavigationStore = create<NavigationStore>((set) => ({
  navigationStore: {} as NavigationStoreState,
  setNavigationStore: (newState) => {
    set((state) => ({
      navigationStore: { ...state, ...newState },
    }));
  },
  resetNavigationStore: () => set({ navigationStore: {} }),
}));
